//导入出游人辅助工具
import XLSX from 'xlsx'

export default class ImportSheetHelper {
  /**
   *   解析表格文件
   * @param file 待解析的文件
   */
  static getSheetDataList(file) {
    console.log('parseFile==', file)
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader()
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result
          const workbook = XLSX.read(data, {
            type: 'binary'
          })
          const sheetList = []
          if (workbook.SheetNames.length > 0) {
            workbook.SheetNames.forEach((wsName, index, names) => {
              let ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsName])//生成json表格内容
              sheetList.push(...ws)
            })
          }
          resolve(sheetList)
        } catch (e) {
          reject(e)
        }
      }
      fileReader.readAsBinaryString(file)
    })

  }

  /**
   *
   * @param file 选中的文件
   * @param keyOrObject 要解析的对象。 如果是字符串（表头），
   * 则解析为一个字符串列表数据。如果是对象，则必须遵守如下协议。
   * （对象的属性名字是解析后的对像的属性，属性值为要解析的表头的值）
   * @returns {Promise<Array>}
   */
  static getSheetDataListFromFile(file, keyOrObject) {
    return new Promise((resolve, reject) => {
        ImportSheetHelper.getSheetDataList(file)
          .then(sheetList => {
            const newDataList = []
            sheetList.forEach((sheetItem, index, arr) => {
              if (typeof keyOrObject === 'string') {
                newDataList.push(sheetItem[keyOrObject])
              } else {
                let newItem = {}
                for (let key in keyOrObject) {
                  newItem[key] = sheetItem[keyOrObject[key]]
                }
                newDataList.push(newItem)
              }
            })
            resolve(newDataList)
          })
          .catch(reason => reject(reason))
      }
    )
  }
}